import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import {
    Paper,
    Divider,
    styled,
    Grid,
    Box,
    Button,
    Modal,
    Typography,
    Card,
    CardHeader,
    CardContent,
    Stack
} from "@mui/material";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import { LABELGENAPI} from '../../../API';
import { fetchConfig } from '../../Settings/Config/configSlice';
import {
  updateQZ
} from "../../Dashboard/onboardingSlice";
const qz = require("qz-tray");

const MultiPackageDimensions = ({ errors, values, multiPackageFields, onMultiPackageAdd, onMultiPackageRemove, handleMultiPackageDimensionInputChange,dispatchShipmentTypeInputChangeCallback }) => {

    const dispatch = useDispatch();
    const box = useSelector(state => state.box);
    const config = useSelector(state => state.config);
    const profile = useSelector(state => state.profile);
    const [qzLinkVisible, setQzLinkVisible] = useState(false)
    const [qzUsbNotConnected, setQzUsbNotConnected] = useState(false)
    const [insuranceCharge, setInsuranceCharge] = useState(0)
    const [boxData, setBoxData] = useState([])

    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: (option) => option.box_name,
      });

    const handleInputChange = e => {
        const { name, value } = e.target
        dispatchShipmentTypeInputChangeCallback(name, value)
    }

    const getWeightScaleStatus = (status) => {
        switch(status) {
			case 1:	// fault
			case 5:	// underweight
			case 6:	// overweight
			case 7:	// calibrate
			case 8:	// re-zero
				status = 'error'; break;
			case 3:
				status = 'busy'; break;
			case 2:	// stable at zero
			case 4: // stable non-zero
			default:
				status = 'stable';
		}

        return status
    }

    const releaseWeightScale = (vendor, product) => {
        qz.hid.isClaimed(vendor, product).then(() => {
            qz.hid.releaseDevice(vendor, product).catch((e) => {
                console.log(e.message)
            }).then(() => {
                console.log("Release and disconnection web socket")
                // qz.websocket.disconnect();
            })
        }).catch((e) => {
            console.log(e.message)
            console.log("Disconnection web socket")
            // qz.websocket.disconnect();
        })
    }

    const getWeightInfo = (data) => {
        console.log("Inside Weight Info =>",data)
        let precision = parseInt(data[3], 16);
        precision = precision ^ -256;
        data.splice(0,4);
        data.reverse();
		let weight = parseInt(data.join(''), 16);
        weight *= Math.pow(10, precision);
        return weight.toFixed(Math.abs(precision));
    }

    const getWeightUnit = (unit) => {
        console.log("Unit code received from scale => "+unit)
        switch(unit) {
			case 3:
				unit = 'kg'; break;
			case 11: // ounces
				unit = 'oz'; break;
			case 12:
			default:
				unit = 'lb';
		}
        return unit
    }

    const convertWeightToKg = (weight, weight_unit) => {
        if(weight_unit == "oz"){
            weight = parseFloat(weight / 35.274).toFixed(2);
        }
        return weight
    }

    const verifySecuritySignature = () => {
        qz.security.setCertificatePromise((resolve, reject) => {
            LABELGENAPI.
            get("/security/digital-certificate").
            then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                console.log(error.response)
                reject(error.response)
            });
        });
        qz.security.setSignatureAlgorithm("SHA512");
        qz.security.setSignaturePromise((toSign) => {
            return (resolve, reject) => {
                LABELGENAPI.
                get("/security/private-key?data="+toSign).
                then(function (response) {
                    resolve(response.data)
                })
                .catch(function (error) {
                    console.log(error.response)
                    reject(error.response)
                });
            };
        });
    }

    const getWeight = (index) => {
        console.log("===================")
        console.log(index)
        console.log("===================")
        verifySecuritySignature();
        console.log("Inside Get Weight")
        if(profile && profile.profile && typeof profile.profile.qz_tray_user === 'undefined' ){
          dispatch(updateQZ())
        }
        if (config &&
            config.data &&
            config.data.weighing_scale &&
            config.data.weighing_scale.is_enabled &&
            config.data.weighing_scale.config &&
            config.data.weighing_scale.config.vendor &&
            config.data.weighing_scale.config.product &&
            config.data.weighing_scale.config.device &&
            config.data.weighing_scale.config.endpoint){
                let vendor = config.data.weighing_scale.config.vendor
                let product = config.data.weighing_scale.config.product
                let device = config.data.weighing_scale.config.device
                let endpoint = config.data.weighing_scale.config.endpoint

                console.log("Config details found !!")

                qz.websocket.connect()
                .then(() => {
                    console.log("Connected. claiming device !!")
                    return qz.hid.claimDevice(vendor, product);
                }).catch((e) => {
                    console.log("catch ==> "+ e.message)
                    if(e.message === "Unable to establish connection with QZ"){
                        setQzLinkVisible(true)
                        setQzUsbNotConnected(false)
                    }
                    if(e.message === "USB device could not be found"){
                        setQzUsbNotConnected(true)
                        setQzLinkVisible(false)
                    }

                    if(e.message == "An open connection with QZ Tray already exists"){
                        console.log("Connection already exists. claiming device !!")
                        return qz.hid.claimDevice(vendor, product);
                    }
                }).then(() => {
                    return qz.hid.readData(vendor, product, '8');
                }).then((data) => {
                    console.log("Data raw",data)
                    setQzLinkVisible(false)
                    setQzUsbNotConnected(false)
                    let status = getWeightScaleStatus(parseInt(data[1], 16));
                    console.log("Scale Status => "+ status)
                    let weight_unit = getWeightUnit(parseInt(data[2], 16))
                    console.log("Scale Weight Unit => "+ weight_unit)
                    let weight = getWeightInfo(data)
                    console.log("Scale Weight => "+ weight)
                    if(weight != ""){
                        if(weight_unit !== "kg" && weight_unit !== "lb"){
                            weight = convertWeightToKg(weight, weight_unit)
                            weight_unit = "kg"
                        }
                        const actualWeightEvent = {
                            "target": {
                                "name": "actual_weight",
                                "value": weight
                            }
                        }
                        const actualWeightUnitEvent = {
                            "target": {
                                "name": "weight_unit",
                                "value": weight_unit
                            }
                        }
                        console.log(actualWeightEvent)
                        console.log(actualWeightUnitEvent)
                        handleMultiPackageDimensionInputChange(index, actualWeightEvent)
                        handleMultiPackageDimensionInputChange(index, actualWeightUnitEvent)
                    }
                }).then(() => {
                    releaseWeightScale(vendor, product)
                }).catch(() => {
                    releaseWeightScale(vendor, product)
                })
            }
    }

    const getChooseMeasurement = (currentvalue) => {
      
        let filteredCurrentValue = {};
        let tempValue = "";
        boxData &&
        boxData.map((key) => {
            if (key._id == currentvalue && tempValue == "") {
                filteredCurrentValue = key;
                tempValue = "success";
            }
          });
        return filteredCurrentValue;
      };

    useEffect(() => {
        dispatch(fetchConfig())
        // setTimeout(function () {
        //     if (values && values.actual_weight == "") { document.getElementById("actual-weight-id").focus(); }
        // }, 1000);
    }, [dispatch]);

    useEffect(() => {
        let tempBoxData=[]
        let customValue={"_id":0,"box_name":"custom"}
        tempBoxData.push(customValue)
        let boxOriginalData = box && box.data.filter(function( obj ) {
            return  obj.hide !== true;
            });
        if (boxOriginalData.length !== 0) {
            boxOriginalData.map((item) => {
                tempBoxData.push(item)
            })
            setBoxData(tempBoxData)
        }else{
            setBoxData(tempBoxData)
        }
    }, [box]);

    return (
        <>
            <Card
                sx={{
                    width: '100%',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden',
                    marginTop: '5px',
                    height: '100%',
                    display: 'flex',          // Added to support dynamic inner container stretching
                    flexDirection: 'column'   // Controls smooth allocation of layout rows natively
                }}
                className="sc--cardhead--details"
            >
                <CardHeader
                    title={
                        <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                            Measurement
                        </Typography>
                    }
                    action={
                        <Button 
                            variant="outlined" 
                            size="small"
                            disabled={multiPackageFields.length >= 20} 
                            aria-label="settings" 
                            onClick={() => onMultiPackageAdd()}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '8px',
                                fontWeight: 700,
                                fontSize: '12.5px',
                                height: '32px',
                                borderColor: '#1976d2',
                                color: '#1976d2',
                                '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderColor: '#115293' },
                                '&.Mui-disabled': { borderColor: '#E2E8F0', color: '#CBD5E1' }
                            }}
                        >
                            Add Package
                        </Button>
                    }
                    sx={{ p: 2.5, backgroundColor: '#FFFFFF', flexShrink: 0 }}
                />
                <Divider sx={{ borderColor: '#E2E8F0', flexShrink: 0 }} />
                
                <CardContent sx={{ p: 3, pb: 0, flexShrink: 0 }}>
                    <Box sx={{ width: '100%' }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="shipment-type-select-outlined-label">Package Type</InputLabel>
                            <Select
                                labelId="shipment-type-select-outlined-label"
                                id="shipment-type-select-outlined"
                                name="shipment_type"
                                onChange={handleInputChange}
                                value={values.shipment_type}
                                label="Package Type"
                                sx={{ 
                                    borderRadius: '10px',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#CBD5E1' },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2' }
                                }}
                            >
                                <MenuItem value="PACKAGE">Package</MenuItem>
                                <MenuItem value="LETTER">Letter</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </CardContent>
                
                {/* Fixed internal scroll pane layout configuration mapping */}
                <CardContent sx={{ p: 3, pt: 1, maxHeight: '500px', overflowY: 'auto', flexGrow: 1 }}>
                    <Stack spacing={2.5}>
                        {multiPackageFields.map((input, index) => {
                            return (
                                <Card 
                                    key={index}
                                    sx={{ 
                                        backgroundColor: '#FFFFFF', 
                                        border: '1px solid #E2E8F0', 
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <CardHeader 
                                        title={
                                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1E293B', fontSize: '14px' }}>
                                                {"Package " + (index + 1)}
                                            </Typography>
                                        } 
                                        action={
                                            <Button 
                                                aria-label="settings" 
                                                variant="outlined" 
                                                size="small"
                                                color="error"
                                                onClick={() => onMultiPackageRemove(index)} 
                                                disabled={multiPackageFields.length == 1}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '6px',
                                                    fontWeight: 700,
                                                    fontSize: '12px',
                                                    height: '26px',
                                                    borderColor: '#FEE2E2',
                                                    color: '#EF4444',
                                                    '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#FCA5A5' },
                                                    '&.Mui-disabled': { borderColor: '#F1F5F9', color: '#CBD5E1' }
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        }
                                        sx={{ p: 2, bgcolor: '#F8FAFC', borderBottom: '1px solid #E2E8F0' }}
                                    />
                                    <Box sx={{ p: 2.5 }}>
                                        <Grid container spacing={2.5}>
                                            
                                            {/* 1. Predefined Saved Dimension Template Dropdown */}
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    className="help-text-error"
                                                    disablePortal
                                                    size="small"
                                                    name="choosenmeasurement"
                                                    id={`package-saved-dim-select-${index}`}
                                                    options={boxData || []}
                                                    autoHighlight
                                                    loading={!!(box && box.loading)}
                                                    getOptionLabel={(option) => option.box_name=='custom' ? ""+option.box_name+"": ( ""+option.box_name+" ("+option.box_length+option.box_length_unit+"x "+ option.box_width+option.box_width_unit+"x "+ option.box_height+option.box_height_unit+", "+option.box_weight+option.box_weight_unit+")")}
                                                    filterOptions={filterOptions}
                                                    value={getChooseMeasurement(multiPackageFields[index].choosenmeasurement)}
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': { 
                                                            borderRadius: '10px',
                                                            '& fieldset': { borderColor: '#E2E8F0' },
                                                            '&:hover fieldset': { borderColor: '#CBD5E1' },
                                                            '&.Mui-focused fieldset': { borderColor: '#1976d2' }
                                                        }
                                                    }}
                                                    renderOption={(props, option) => (
                                                        <MenuItem {...props} value={option._id} key={option._id} sx={{ py: 1, borderBottom: '1px solid #F1F5F9' }}>
                                                        {option.box_name =='custom' ? (
                                                            <Typography variant="body2" sx={{ margin: 'unset', color: '#1E293B', fontWeight: 600 }}>
                                                            {option.box_name}
                                                            </Typography>
                                                        ) : (
                                                            <Typography variant="body2" sx={{ margin: 'unset', color: '#334155', fontWeight: 500 }}>
                                                                {option.box_name} (
                                                                {option.box_length}{option.box_length_unit} <Box component="span" sx={{ color: '#1976d2', fontWeight: 700 }}> x </Box>
                                                                {option.box_width}{option.box_width_unit} <Box component="span" sx={{ color: '#1976d2', fontWeight: 700 }}> x </Box>
                                                                {option.box_height}{option.box_height_unit}<span>, </span>
                                                                {option.box_weight}{option.box_weight_unit})
                                                            </Typography>
                                                        )}
                                                        </MenuItem>
                                                    )}
                                                    onChange={(event, value) => {
                                                        if (value !== null) {
                                                            let event={
                                                                        "target":{
                                                                            "name":"choosenmeasurement",
                                                                            "value":value._id
                                                                        }}
                                                            handleMultiPackageDimensionInputChange(index,event)
                                                        } 
                                                    }}
                                                    renderInput={(params) => (
                                                        <Box sx={{
                                                            '& .MuiInputLabel-root': { transform: 'translate(14px, 9px) scale(1)' },
                                                            '& .MuiInputLabel-shrink': { transform: 'translate(14px, -9px) scale(0.75)' }
                                                        }}>
                                                            <TextField
                                                                {...params}
                                                                label="Choose Measurement"
                                                                variant="outlined"
                                                                helperText={errors.province}
                                                            />
                                                        </Box>
                                                    )}
                                                />
                                            </Grid>

                                            {/* 2. Multi-Vector Volumetric Dimensional Input Row Mapping Grid */}
                                            <Grid item xs={12} sm={4} md={4} lg={3}>
                                                <TextField 
                                                    label="Length*"
                                                    variant="outlined"
                                                    size="small"
                                                    name="length"
                                                    type="number"
                                                    inputProps={{ min: 1 }}
                                                    value={multiPackageFields[index].length}
                                                    onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                    error={!!(errors && errors[index] && errors[index].length)}
                                                    helperText={errors && errors[index] && errors[index].length}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4} md={4} lg={3}>
                                                <TextField 
                                                    label="Width*"
                                                    variant="outlined"
                                                    size="small"
                                                    name="width"
                                                    type="number"
                                                    inputProps={{ min: 1 }}
                                                    value={multiPackageFields[index].width}
                                                    onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                    error={!!(errors && errors[index] && errors[index].width)}
                                                    helperText={errors && errors[index] && errors[index].width}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4} md={4} lg={3}>
                                                <TextField 
                                                    label="Height*"
                                                    variant="outlined"
                                                    size="small"
                                                    name="height"
                                                    type="number"
                                                    inputProps={{ min: 1 }}
                                                    value={multiPackageFields[index].height}
                                                    onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                    error={!!(errors && errors[index] && errors[index].height)}
                                                    helperText={errors && errors[index] && errors[index].height}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                <FormControl fullWidth variant="outlined" size="small" error={!!(errors && errors[index] && errors[index].dimension_unit)}>
                                                    <InputLabel id={`dim-unit-outlined-label-${index}`} sx={{ color: errors && errors[index] && errors[index].dimension_unit ? '#D32F2F' : undefined }}>Dim Unit*</InputLabel>
                                                    <Select
                                                        labelId={`dim-unit-outlined-label-${index}`}
                                                        name="dimension_unit"
                                                        onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                        value={multiPackageFields[index].dimension_unit}
                                                        label="Dim Unit*"
                                                        sx={{ borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } }}
                                                    >
                                                        <MenuItem value="in">in</MenuItem>
                                                        <MenuItem value="cm">cm</MenuItem>
                                                    </Select>
                                                    {errors && errors[index] && errors[index].dimension_unit && <FormHelperText>{errors[index].dimension_unit}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                                <TextField 
                                                    label="Weight*"
                                                    variant="outlined"
                                                    size="small"
                                                    name="actual_weight"
                                                    type="number"
                                                    inputProps={{ min: 1 }}
                                                    value={multiPackageFields[index].actual_weight}
                                                    autoFocus={true}
                                                    onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                    error={!!(errors && errors[index] && errors[index].actual_weight)}
                                                    helperText={errors && errors[index] && errors[index].actual_weight}
                                                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                />
                                            </Grid>

                                            {/* 3. Mass Metrics Weight Unit Selection Container Field */}
                                            <Grid item xs={12}  md={6} lg={6}>
                                                <FormControl sx={{ width: { xs: '100%', sm: '50%' } }} variant="outlined" size="small" error={!!(errors && errors[index] && errors[index].weight_unit)}>
                                                    <InputLabel id={`wgt-unit-outlined-label-${index}`} sx={{ color: errors && errors[index] && errors[index].weight_unit ? '#D32F2F' : undefined }}>Weight Unit*</InputLabel>
                                                    <Select
                                                        labelId={`wgt-unit-outlined-label-${index}`}
                                                        name="weight_unit"
                                                        onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                        value={multiPackageFields[index].weight_unit}
                                                        label="Weight Unit*"
                                                        sx={{ borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } }}
                                                    >
                                                        <MenuItem value="lb">lb</MenuItem>
                                                        <MenuItem value="kg">kg</MenuItem>
                                                        <MenuItem value="g">g</MenuItem>
                                                    </Select>
                                                    {errors && errors[index] && errors[index].weight_unit && <FormHelperText>{errors[index].weight_unit}</FormHelperText>}
                                                </FormControl>
                                            </Grid>

                                            {/* 4. Dynamic Protection Shield Valuation Matrix */}
                                            {profile && profile.profile.is_custom_insurance_field_required && profile.profile.is_custom_insurance_field_required == true ? (
                                                <>
                                                    <Grid item xs={12} sm={8}>
                                                        <TextField 
                                                            label="Insurance Amount (Optional)"
                                                            variant="outlined"
                                                            size="small"
                                                            name="insurance_amount"
                                                            type="number"
                                                            inputProps={{ min: 100, step: 100 }}
                                                            value={multiPackageFields[index].insurance_amount}
                                                            autoFocus={true}
                                                            onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                            error={!!(errors && errors[index] && errors[index].insurance_amount)}
                                                            helperText={errors && errors[index] && errors[index].insurance_amount}
                                                            sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <TextField 
                                                            label="Charge"
                                                            variant="outlined"
                                                            size="small"
                                                            name="insurance_charge"
                                                            type="number"
                                                            disabled
                                                            value={((Math.ceil(multiPackageFields[index].insurance_amount / 100) - 1) * 2.25) >= 2.25 ? (Math.ceil(multiPackageFields[index].insurance_amount / 100) - 1) * 2.25 : 0}
                                                            sx={{
                                                                width: '100%',
                                                                '& .MuiOutlinedInput-root': {
                                                                    borderRadius: '10px',
                                                                    backgroundColor: '#F8FAFC',
                                                                    '& fieldset': { borderColor: '#E2E8F0' },
                                                                    '& input': { color: '#0F172A', fontWeight: 700 }
                                                                }
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            ) : (
                                                <Grid item xs={12}>
                                                    <TextField 
                                                        label="Insurance Amount (Optional)"
                                                        variant="outlined"
                                                        size="small"
                                                        name="insurance_amount"
                                                        type="number"
                                                        inputProps={{ min: 1 }}
                                                        value={multiPackageFields[index].insurance_amount}
                                                        autoFocus={true}
                                                        onChange={event => handleMultiPackageDimensionInputChange(index, event)}
                                                        error={!!(errors && errors[index] && errors[index].insurance_amount)}
                                                        helperText={errors && errors[index] && errors[index].insurance_amount}
                                                        sx={{ width: { xs: '100%', sm: '50%' }, '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }}
                                                    />
                                                </Grid>
                                            )}

                                            {/* Informational Platform Threshold Descriptor */}
                                            <Grid item xs={12}>
                                                <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 500, fontSize: '12px', fontStyle: 'italic', display: 'block', mt: -0.5 }}>
                                                    Note : Free insurance upto $100.
                                                </Typography>
                                            </Grid>

                                            {/* Peripheral Scale Workstation Sync Trigger */}
                                            <Grid item xs={12}>
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                    {(config && config.data && config.data.weighing_scale && config.data.weighing_scale.is_enabled) && (
                                                        <Button 
                                                            variant="outlined" 
                                                            size="small"
                                                            onClick={() => getWeight(index)}
                                                            sx={{
                                                                textTransform: 'none',
                                                                borderRadius: '8px',
                                                                fontWeight: 700,
                                                                fontSize: '12.5px',
                                                                borderColor: '#E2E8F0',
                                                                color: '#475569',
                                                                '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC' }
                                                            }}
                                                        >
                                                            Get Weight
                                                        </Button>
                                                    )}
                                                </Box>
                                            </Grid>

                                        </Grid>
                                    </Box>
                                </Card>
                            );
                        })}
                    </Stack>

                    {/* Hardware Layer Error Notification Banners */}
                    {qzLinkVisible && (
                        <Box sx={{ width: '100%', mt: 2, display: 'flex', justifyContent: 'center', p: 1.5, backgroundColor: '#FEF2F2', borderRadius: '10px', border: '1px solid #FCA5A5', flexShrink: 0 }}>
                            <Typography variant="caption" sx={{ color: '#B91C1C', fontWeight: 600, fontSize: '12.5px', textAlign: 'center' }}>
                                Unable to establish connection with local QZ Tray workflow cluster. Please ensure the desktop asset is active or complete the configuration <a href="https://qz.io/download/" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', fontWeight: 700, textDecoration: 'underline' }}>setup</a>.
                            </Typography>
                        </Box>
                    )}
                    {qzUsbNotConnected && (
                        <Box sx={{ width: '100%', mt: 2, display: 'flex', justifyContent: 'center', p: 1.5, backgroundColor: '#FEF2F2', borderRadius: '10px', border: '1px solid #FCA5A5', flexShrink: 0 }}>
                            <Typography variant="caption" sx={{ color: '#B91C1C', fontWeight: 600, fontSize: '12.5px', textAlign: 'center' }}>
                                Hardware Pipeline Warning: Please verify your peripheral USB Weighing Scale hub interface is securely mounted to this workstation.
                            </Typography>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </>)
}

export default MultiPackageDimensions;